import { render, staticRenderFns } from "./UserRating.vue?vue&type=template&id=8ce0f81a&scoped=true&"
import script from "./UserRating.vue?vue&type=script&lang=js&"
export * from "./UserRating.vue?vue&type=script&lang=js&"
import style0 from "./UserRating.vue?vue&type=style&index=0&id=8ce0f81a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce0f81a",
  null
  
)

export default component.exports